import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
    FiHome,
    FiBox,
    FiSettings
} from "react-icons/fi";
import {
    FaChevronLeft,
    FaChevronRight,
    FaProductHunt,
    FaSignOutAlt,
    FaChevronDown,
    FaChevronUp
} from "react-icons/fa";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { LiaStoreSolid } from "react-icons/lia";
import { TbRouteSquare } from "react-icons/tb";
import { MdOutlineCategory } from "react-icons/md";
import { RiTruckLine } from "react-icons/ri";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import logo from "../../assets/logos/logo.png";
import { GoCreditCard } from "react-icons/go";


const Sidebar = ({ isOpen, setIsOpen }) => {
    const navigate = useNavigate();
    const [isInventoryOpen, setInventoryOpen] = useState(false);
    const companyName = localStorage.getItem('company_name');

    const menuItems = [
        { name: "Dashboard", path: "/dashboard", icon: <FiHome /> },
        { name: "Orders", path: "/orders", icon: <HiOutlineShoppingCart /> },
        { name: "Products", path: "/products", icon: <FaProductHunt /> },
        { name: "Categories", path: "/categories", icon: <MdOutlineCategory /> },
        { name: "Inventory", path: "/inventory", icon: <FiBox /> },
        { name: "Stores", path: "/stores", icon: <LiaStoreSolid /> },
        { name: "Routes", path: "/routes", icon: <TbRouteSquare /> },
        { name: "Dropers", path: "/dropers", icon: <RiTruckLine /> },
        { name: "Credits", path: "/credits", icon: <GoCreditCard /> },
        { name: "Reports", path: "/reports", icon: <HiOutlineClipboardDocumentList /> },
        { name: "Settings", path: "/settings", icon: <FiSettings /> },
    ];

    const inventoryOptions = [
        { name: "Stock Inflow", path: "/inventory/stock-inflow" },
        { name: "Stock Return", path: "/inventory/stock-return" },
        { name: "Stock Reports", path: "/inventory/stock-report" },
    ];

    const handleLogout = () => {
        console.log("Logging out...");
        localStorage.clear();
        navigate('/');
    };

    return (
        <div
            className={`${isOpen ? "w-64" : "w-16"} bg-primary text-white fixed h-full transition-all duration-300 z-50 flex flex-col`}
        >
            <div
                className="flex items-center justify-between p-4 cursor-pointer border-b border-r border-blue-600"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-xl font-bold flex items-center w-full">
                    {isOpen ? (
                        <div className="flex w-full items-center justify-between">
                            <div className="flex gap-3 items-center">
                                <img
                                    src={logo}
                                    alt="Company Logo"
                                    className="object-cover rounded"
                                    style={{ height: '25px', width: '25px' }}
                                />
                                <span title={companyName} className="text-start fs_16 truncate">{companyName ? companyName?.toLocaleUpperCase() : "INVETIX"}</span>
                            </div>
                            <FaChevronLeft className="ml-2" />
                        </div>
                    ) : (
                        <div className="flex w-full items-center justify-between my-1">
                            <FaChevronRight />
                        </div>
                    )}
                </span>
            </div>

            {/* Menu Items */}
            <ul className="flex-grow overflow-y-auto mt-2">
                {menuItems.map((item, index) => (
                    <li key={index}>
                        <NavLink
                            to={item.path}
                            className="flex items-center p-4 hover:bg-blue-700 transition-colors"
                            activeClassName="bg-blue-900"
                        >
                            <span className="text-lg">{item.icon}</span>
                            {isOpen && <span className="ml-4">{item.name}</span>}
                        </NavLink>
                    </li>
                ))}

                {/* Inventory Dropdown */}
                {/* <li>
                    <div
                        className="flex items-center p-4 hover:bg-blue-700 transition-colors cursor-pointer"
                        onClick={() => { setInventoryOpen(!isInventoryOpen) }}
                    >
                        <span className="text-lg" onClick={() => navigate('/inventory')} > <FiBox /></span>
                        {isOpen && (
                            <>
                                <span className="ml-4" onClick={() => navigate('/inventory')} >Inventory</span>
                                <span className="ml-auto">
                                    {isInventoryOpen ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </>
                        )}
                    </div>
                    {isInventoryOpen && (
                        <ul className="ml-6">
                            {inventoryOptions.map((option, index) => (
                                <li key={index}>
                                    <NavLink
                                        to={option.path}
                                        className="flex items-center p-2 hover:bg-blue-700 transition-colors"
                                        activeClassName="bg-blue-900"
                                    >
                                        {isOpen && <span className="ml-4">{option.name}</span>}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    )}
                </li> */}
            </ul>

            {/* Logout Option */}
            <div className="pb-8 w-full">
                <button
                    onClick={handleLogout}
                    className="flex items-center p-4 hover:bg-blue-700 transition-colors w-full text-left"
                >
                    <FaSignOutAlt className="text-lg" />
                    {isOpen && <span className="ml-4">Logout</span>}
                </button>
            </div>
        </div >
    );
};

export default Sidebar;
